var bittoelatings_e = [{
    rule: "vaardighede:create",
    bitmask: "1",
    blok: 4,
    beskrywing: "Skep 'n vaardigheid",
    groepe: ["vaardighede", "setup"]
},
{
    rule: "vaardighede:read",
    bitmask: "2",
    blok: 4,
    beskrywing: "Lees van vaardighede",
    groepe: ["vaardighede", "setup"]
},
{
    rule: "vaardighede:update",
    bitmask: "4",
    blok: 4,
    beskrywing: "Veranderinge aan vaardigheid",
    groepe: ["vaardighede", "setup"]
},
{
    rule: "vaardighede:delete",
    bitmask: "8",
    blok: 4,
    beskrywing: "Verwydering van pes vaardigheid",
    groepe: ["vaardighede", "setup"]
},
{
    rule: "aktiwiteitemodule:toegang",
    bitmask: "16",
    blok: 4,
    beskrywing: "Toegang tot aktiwiteite module",
    groepe: ["aktiwiteite", "setup"]
},
{
    rule: "modules:create",
    bitmask: "32",
    blok: 4,
    beskrywing: "Aktiveer 'n module",
    groepe: ["modules", "setup"]
},
{
    rule: "modules:read",
    bitmask: "64",
    blok: 4,
    beskrywing: "Lees van modules",
    groepe: ["modules", "setup"]
},
{
    rule: "modules:update",
    bitmask: "128",
    blok: 4,
    beskrywing: "Veranderinge aan modules",
    groepe: ["modules", "setup"]
},
{
    rule: "modules:delete",
    bitmask: "256",
    blok: 4,
    beskrywing: "De-aktivering van modules",
    groepe: ["modules", "setup"]
},
{
    rule: "toerusting:create",
    bitmask: "512",
    blok: 4,
    beskrywing: "Skep van toerusting",
    groepe: ["toerusting", "setup"]
},
{
    rule: "toerusting:read",
    bitmask: "1024",
    blok: 4,
    beskrywing: "Lees van toerusting",
    groepe: ["toerusting", "setup"]
},
{
    rule: "toerusting:update",
    bitmask: "2048",
    blok: 4,
    beskrywing: "Veranderinge aan toerusting",
    groepe: ["toerusting", "setup"]
},
{
    rule: "toerusting:delete",
    bitmask: "4096",
    blok: 4,
    beskrywing: "Verwyder van toerusting",
    groepe: ["toerusting", "setup"]
},
{
    rule: "huuritems:create",
    bitmask: "8192",
    blok: 4,
    beskrywing: "Skep van huur-items",
    groepe: ["huuritems", "setup"]
},
{
    rule: "huuritems:read",
    bitmask: "16384",
    blok: 4,
    beskrywing: "Lees van huur-items",
    groepe: ["huuritems", "setup"]
},
{
    rule: "huuritems:update",
    bitmask: "32768",
    blok: 4,
    beskrywing: "Veranderinge aan huur-items",
    groepe: ["huuritems", "setup"]
},
{
    rule: "huuritems:delete",
    bitmask: "65536",
    blok: 4,
    beskrywing: "Verwyder van huur-items",
    groepe: ["huuritems", "setup"]
},
{
    rule: "dienste:create",
    bitmask: "131072",
    blok: 4,
    beskrywing: "Versoek/aktivering van diens",
    groepe: ["dienste", "setup"]
},
{
    rule: "dienste:read",
    bitmask: "262144",
    blok: 4,
    beskrywing: "Lees van dienste",
    groepe: ["dienste", "setup"]
},
{
    rule: "dienste:update",
    bitmask: "524288",
    blok: 4,
    beskrywing: "Verandering aan diens-implementasie",
    groepe: ["dienste", "setup"]
},
{
    rule: "dienste:delete",
    bitmask: "1048576",
    blok: 4,
    beskrywing: "Verwyder van diens",
    groepe: ["dienste", "setup"]
},
{
    rule: "verbruiksitem:create",
    bitmask: "2097152‬",
    blok: 4,
    beskrywing: "Skep van verbruiksitems",
    groepe: ["verbruiksitem", "setup"]
},
{
    rule: "verbruiksitem:read",
    bitmask: "4194304‬",
    blok: 4,
    beskrywing: "Lees van verbruiksitems",
    groepe: ["verbruiksitem", "setup"]
},
{
    rule: "verbruiksitem:update",
    bitmask: "8388608",
    blok: 4,
    beskrywing: "Veranderinge aan verbruiksitems",
    groepe: ["verbruiksitem", "setup"]
},
{
    rule: "verbruiksitem:delete",
    bitmask: "16777216",
    blok: 4,
    beskrywing: "Verwyder van verbruiksitems",
    groepe: ["verbruiksitem", "setup"]
},
{
    rule: "betaalmetode:create",
    bitmask: "33554432",
    blok: 4,
    beskrywing: "Skep van betaalmetode",
    groepe: ["verbruiksitem", "setup"]
},
{
    rule: "betaalmetode:read",
    bitmask: "67108864",
    blok: 4,
    beskrywing: "Lees van betaalmetode",
    groepe: ["betaalmetode", "setup"]
},
{
    rule: "betaalmetode:update",
    bitmask: "134217728",
    blok: 4,
    beskrywing: "Veranderinge aan betaalmetode",
    groepe: ["betaalmetode", "setup"]
},
{
    rule: "betaalmetode:delete",
    bitmask: "268435456",
    blok: 4,
    beskrywing: "Verwyder van betaalmetode",
    groepe: ["betaalmetode", "setup"]
},
{
    rule: "eersteplukdatum:update",
    bitmask: "536870912",
    blok: 4,
    beskrywing: "Stel van 'n blok se eerste plukdatum",
    groepe: ["eersteplukdatum", "blok"]
},
{
    rule: "qrkodes:create",
    bitmask: "1073741824",
    blok: 4,
    beskrywing: "Skep van QR Kodes",
    groepe: ["operationeel"]
},
];

export default bittoelatings_e;